import * as ngCore from '@angular/core'
import type * as ents from '@attain-apps/entities'
import * as rxjs from 'rxjs'

import * as gql from './gql'
import type * as types from './types'

/**
 * API wrapper for survey configuration GraphQL operations
 */
@ngCore.Injectable()
export class Api {
  /**
   * Fetches survey configuration for the current scenario
   */
  public get(
    context: types.Context,
  ): rxjs.Observable<ents.extra.space.SurveyConfiguration | undefined> {
    if (!context) {
      return rxjs.of(undefined)
    }

    return gql.queries.surveyConfiguration.executor(context)
  }

  /**
   * Upserts survey configuration for the current scenario
   */
  public upsert(
    context: types.Context,
    input: ents.extra.space.SurveyConfiguration.Input,
  ): rxjs.Observable<void> {
    if (!context) {
      return rxjs.of(undefined)
    }

    return gql.mutations.upsertSurveyConfiguration.executor({
      ...context,
      input: gql.inputs.surveyConfiguration.INPUT.getGqlFrom(input),
    })
  }
}
